import { EChartIndicator, ITechnicalIndicator } from '@aqx-core/common/api/user-account-setting';

import { EEventMessageType } from './event';

export interface ITooltipOption {
  type: () => string;
  labels: () => string[];
}

export interface IPostEventIndicatorMessage {
  type: typeof EEventMessageType.INDICATOR;
  data: EChartIndicator;
}

export interface IUpdateIndicatorParams {
  technicalIndicatorList: ITechnicalIndicator[];
  onComplete?: () => void;
}

export interface IPostEventIndicatorMessage {
  type: typeof EEventMessageType.INDICATOR;
  data: EChartIndicator;
  needSort?: boolean;
}

export interface IReceiveEventIndicatorMessage {
  type: typeof EEventMessageType.INDICATOR;
  data: EChartIndicator;
}

export enum EInputType {
  DECIMAL = 'DECIMAL',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export interface IPostEventUpdateIndicatorMessageData extends ITechnicalIndicator {}

export interface IReceiveOpenIndicatorConfigMessageData {
  indicator: EChartIndicator;
}

export interface IReceiveEventOpenIndicatorFormMessage {
  type: typeof EEventMessageType.OPEN_INDICATOR_CONFIG;
  data: IReceiveOpenIndicatorConfigMessageData;
}

export interface IPostEventUpdateIndicatorFormMessage {
  type: typeof EEventMessageType.UPDATE_INDICATOR_CONFIG;
  data: IPostEventUpdateIndicatorMessageData;
}

export interface IPostEventTokenFormMessage {
  type: typeof EEventMessageType.TOKEN;
  data: string;
}
